import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { getSiteMode } from './lib/siteContext';
import reportWebVitals from './reportWebVitals';

/**
 * Root Application Entry Point
 *
 * Detects whether we're on the B2B or B2C subdomain and renders
 * the appropriate application.
 *
 * B2B (main site): infibrite.com, lvh.me:3000, localhost:3000
 * B2C (shop): shop.infibrite.com, shop.lvh.me:3000, localhost:3000?mode=b2c
 */
const siteMode = getSiteMode();
const B2CApp = React.lazy(() => import('./b2c/App'));
const BusinessApp = React.lazy(() => import('./App'));
const RootApp = siteMode === 'b2c' ? B2CApp : BusinessApp;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Suspense fallback={<div className="min-h-screen bg-white" aria-label="Loading Infibrite" />}>
      <RootApp />
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
